import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import SimpleBar from 'simplebar-core';
const _c0 = ["*"];
let SimplebarAngularComponent = /*#__PURE__*/(() => {
  class SimplebarAngularComponent {
    constructor(elRef, zone) {
      this.zone = zone;
      this.options = {};
      this.elRef = elRef;
    }
    ngOnInit() {
      this.ariaLabel = this.options.ariaLabel || SimpleBar.defaultOptions.ariaLabel;
      this.tabIndex = (this.options.tabIndex || SimpleBar.defaultOptions.tabIndex).toString();
    }
    ngAfterViewInit() {
      this.zone.runOutsideAngular(() => {
        this.SimpleBar = new SimpleBar(this.elRef.nativeElement, this.options || {});
      });
    }
    ngOnDestroy() {
      this.SimpleBar?.unMount();
      this.SimpleBar = null;
    }
    static {
      this.ɵfac = function SimplebarAngularComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SimplebarAngularComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SimplebarAngularComponent,
        selectors: [["ngx-simplebar"]],
        hostAttrs: ["data-simplebar", "init"],
        inputs: {
          options: "options"
        },
        standalone: false,
        ngContentSelectors: _c0,
        decls: 13,
        vars: 2,
        consts: [[1, "simplebar-wrapper"], [1, "simplebar-height-auto-observer-wrapper"], [1, "simplebar-height-auto-observer"], [1, "simplebar-mask"], [1, "simplebar-offset"], ["role", "region", 1, "simplebar-content-wrapper"], [1, "simplebar-content"], [1, "simplebar-placeholder"], [1, "simplebar-track", "simplebar-horizontal"], [1, "simplebar-scrollbar"], [1, "simplebar-track", "simplebar-vertical"]],
        template: function SimplebarAngularComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(8, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵelement(10, "div", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 10);
            i0.ɵɵelement(12, "div", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵattribute("tabIndex", ctx.tabIndex)("aria-label", ctx.ariaLabel);
          }
        },
        styles: ["[data-simplebar]{position:relative;flex-direction:column;flex-wrap:wrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start}.simplebar-wrapper{overflow:hidden;width:inherit;height:inherit;max-width:inherit;max-height:inherit}.simplebar-mask{direction:inherit;position:absolute;overflow:hidden;padding:0;margin:0;inset:0;width:auto!important;height:auto!important;z-index:0}.simplebar-offset{direction:inherit!important;box-sizing:inherit!important;resize:none!important;position:absolute;inset:0;padding:0;margin:0;-webkit-overflow-scrolling:touch}.simplebar-content-wrapper{direction:inherit;box-sizing:border-box!important;position:relative;display:block;height:100%;width:auto;max-width:100%;max-height:100%;overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.simplebar-content-wrapper::-webkit-scrollbar,.simplebar-hide-scrollbar::-webkit-scrollbar{display:none;width:0;height:0}.simplebar-content:before,.simplebar-content:after{content:\" \";display:table}.simplebar-placeholder{max-height:100%;max-width:100%;width:100%;pointer-events:none}.simplebar-height-auto-observer-wrapper{box-sizing:inherit!important;height:100%;width:100%;max-width:1px;position:relative;float:left;max-height:1px;overflow:hidden;z-index:-1;padding:0;margin:0;pointer-events:none;flex-grow:inherit;flex-shrink:0;flex-basis:0}.simplebar-height-auto-observer{box-sizing:inherit;display:block;opacity:0;position:absolute;top:0;left:0;height:1000%;width:1000%;min-height:1px;min-width:1px;overflow:hidden;pointer-events:none;z-index:-1}.simplebar-track{z-index:1;position:absolute;right:0;bottom:0;pointer-events:none;overflow:hidden}[data-simplebar].simplebar-dragging,[data-simplebar].simplebar-dragging .simplebar-content{pointer-events:none;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[data-simplebar].simplebar-dragging .simplebar-track{pointer-events:all}.simplebar-scrollbar{position:absolute;left:0;right:0;min-height:10px}.simplebar-scrollbar:before{position:absolute;content:\"\";background:#000;border-radius:7px;left:2px;right:2px;opacity:0;transition:opacity .2s .5s linear}.simplebar-scrollbar.simplebar-visible:before{opacity:.5;transition-delay:0s;transition-duration:0s}.simplebar-track.simplebar-vertical{top:0;width:11px}.simplebar-scrollbar:before{inset:2px}.simplebar-track.simplebar-horizontal{left:0;height:11px}.simplebar-track.simplebar-horizontal .simplebar-scrollbar{inset:0 auto 0 0;min-height:0;min-width:10px;width:auto}[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical{right:auto;left:0}.simplebar-dummy-scrollbar-size{direction:rtl;position:fixed;opacity:0;visibility:hidden;height:500px;width:500px;overflow-y:hidden;overflow-x:scroll;-ms-overflow-style:scrollbar!important}.simplebar-dummy-scrollbar-size>div{width:200%;height:200%;margin:10px 0}.simplebar-hide-scrollbar{position:fixed;left:0;visibility:hidden;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}\n", "ngx-simplebar{display:block}\n"],
        encapsulation: 2
      });
    }
  }
  return SimplebarAngularComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SimplebarAngularModule = /*#__PURE__*/(() => {
  class SimplebarAngularModule {
    static {
      this.ɵfac = function SimplebarAngularModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SimplebarAngularModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SimplebarAngularModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return SimplebarAngularModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of simplebar-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SimplebarAngularComponent, SimplebarAngularModule };
